(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mg-breadcrumbs-blog"] && !Shopify.designMode) return;
  try {
    const el = document.querySelector('.breadcrumbs-list');
  if (el && el.scrollWidth > el.clientWidth) {
    el.scrollTo({
      left: el.scrollWidth,
      behavior: 'smooth',
    });
  }
  } catch(e) { console.error(e); }
})();

})();
